import React from "react";
import {useTheme} from "../../../../theme/ThemeProvider";
import ChipBase from "./ChipBase";
import PropTypes from "prop-types";

const CircularChipBase = ({
  children,
  sx = {},
  chipSize = "30px",
  chipColor = "success400",
  borderColor = "success600",
  ...props
}) => {
  const {theme} = useTheme();

  const override = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: `3px solid`,
    padding: 0,
    borderColor: theme.colors[borderColor] || borderColor,
    width: chipSize,
    height: chipSize,
    backgroundColor: theme.colors[chipColor] || chipColor,
    ...sx,
  };

  return (
    <ChipBase sx={override} {...props}>
      {children}
    </ChipBase>
  );
};

CircularChipBase.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.any,
};
export default CircularChipBase;
